import React from 'react'
import { connect } from 'dva'
import actions from '../../../actions'
import PropTypes from 'prop-types'
import StarIcon from '../../../../../../../assets/svg/StarIcon'
import styles from '../../FeatureIconEditor.module.scss'

function IconItem(props) {
	const handleFavoriteIcon = (event) => {
		event.stopPropagation()
		props.addFavoriteIcon(props.name)
	}
	const handleSelectIcon = (event) => {
		event.stopPropagation()
		const { name, selectedFeature } = props
		const { color } = selectedFeature.properties
		props.selectIcon(selectedFeature, color, name)
	}

	return (
		<>
			<div className={`${styles.iconItemSection} ${props.isSelected && styles.iconSelected}`} onClick={handleSelectIcon}>
				<div className={styles.iconItemSectionHeader}>
					<div className={styles.leftSection}>
						<img width={24} height={24} src={props.image} />
						<div className={styles.iconItemName}>
							<p>{props.title}</p>
						</div>
					</div>
					<div className={styles.rightSection}>
						<i className={styles.favoriteIcon} onClick={handleFavoriteIcon}>
							{props.isSelected ? (
								<StarIcon fill={props.isFavorited ? '#1a1a1b' : '#fff'} size={20} stroke='#1a1a1b' />
							) : (
								<StarIcon fill={props.isFavorited ? '#fff' : null} size={20} stroke={props.isFavorited ? '#fff' : '#8e8e92'} />
							)}
						</i>
					</div>
				</div>
			</div>
		</>
	)
}

IconItem.propTypes = {
	image: PropTypes.any,
	isFavorited: PropTypes.bool,
	isSelected: PropTypes.bool,
	name: PropTypes.string,
	selectedFeature: PropTypes.object,
	title: PropTypes.string,
	//
	addFavoriteIcon: PropTypes.func,
	selectIcon: PropTypes.func,
}

export default connect((model, currentProps) => {
	const { preferences, selectedFeature, selectedIcon } = model.features
	const isFavorited = preferences.favorites.icons.includes(currentProps.name)
	let isSelected = selectedFeature.properties.icon === currentProps.name
	if (selectedIcon) {
		isSelected = selectedIcon === currentProps.name
	}
	return {
		isFavorited,
		isSelected,
		selectedFeature,
	}
}, actions)(IconItem)
